enum DeviceType {
    CONSOLE = 'CONSOLE',
    DESKTOP = 'DESKTOP',
    DONGLE = 'DONGLE',
    MOBILE = 'MOBILE',
    TV = 'TV'
}

export default DeviceType;